import { mountShell } from './shell/Shell';
import './styles/base.scss';
import { mountDownloadForm } from './views/downloadForm/DownloadForm';
import { mountQueuePanel } from './views/queuePanel/QueuePanel';

/**
 * Point d'entrée du client : monte le shell puis les deux vues qu'il
 * héberge (formulaire d'ajout et panneau de file d'attente), et les relie
 * entre elles (un ajout réussi rafraîchit immédiatement la file).
 */
function main(): void {
	const root = document.getElementById('app');
	if (!root) {
		throw new Error("Élément racine '#app' introuvable dans le document.");
	}

	const { downloadFormRoot, queuePanelRoot } = mountShell(root);
	const queuePanel = mountQueuePanel(queuePanelRoot);
	mountDownloadForm(downloadFormRoot, { onItemQueued: () => queuePanel.refresh() });
}

main();
